var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "mx-3",
      staticStyle: { position: "relative", "flex-wrap": "nowrap" },
      style: {
        maxHeight: 16 * _vm.gridUnitSize + "px"
      },
      attrs: {
        row: "",
        "align-start": "",
        "justify-space-between": "",
        id: "manhole-mask-tab"
      }
    },
    [
      _c(
        "v-flex",
        { staticClass: "mr-3", attrs: { xs1: "" } },
        [_c("mask-management")],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "mr-3",
          staticStyle: { "max-height": "inherit" },
          attrs: { xs8: "" }
        },
        [_c("mask-grid", { key: _vm.$store.getters.getSelectedMaskIndex })],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          style: {
            height: 16 * _vm.gridUnitSize + "px"
          },
          attrs: { xs4: "" }
        },
        [
          _vm.activeSideSection === "toolbar"
            ? _c("mask-toolbar")
            : _vm.activeSideSection === "ductEntryTypeSelector"
            ? _c("duct-entries-selector")
            : _vm.activeSideSection === "ductEntryForm"
            ? _c("duct-entry-form")
            : _vm.activeSideSection === "ductEntryAction"
            ? _c("duct-entry-action")
            : _vm.activeSideSection === "maskMirror"
            ? _c("mask-mirror")
            : _vm.activeSideSection === "maskResize"
            ? _c("mask-resize")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("loading-spinner", {
        attrs: { active: _vm.loading, "is-full-page": false, color: "accent" },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa9e8896", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa9e8896","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Masks/MasksTab.vue
// module id = null
// module chunks = 